import * as React from "react";
import { Background } from "./background";
import { Footer } from "./footer";
import { style } from "glamor";

interface IBrandingProps {
    images: string[];
    model?: any;
}

const Branding: React.FC<IBrandingProps> = ({ model, images }) => {
    const absoluteImages = React.useMemo(() => {
        if (model) {
            // for backwards compat, we need to map it
            return images.map((image: string) => "https://cdn1.nuorder.com/branded_login_hero/" + image + ".jpg");
        }
        return images;
    }, [model, images]);
    return (
        <div>
            <div
                {...style({
                    background: "radial-gradient( circle, rgba(0,0,0, .3), rgba(0,0,0, .1))",
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    zIndex: 1,
                })}
            />
            <Background images={absoluteImages} />
            <Footer model={model} />
        </div>
    );
};
export { Branding };
export default Branding;
